import Vue from 'vue';
import Vuelidate from 'vuelidate';

import AffordabilityCalculator from './AffordabilityCalculator.vue';

// Module styles
import '../vue-calculator.scss';
import './affordability-calculator.scss';

Vue.use(Vuelidate);

export default el =>
  new Vue({
    el,
    render: h => h(AffordabilityCalculator),
  });
